export default __webpack_public_path__ + "static/FTRegolaNeue-Regular-209dfa6c4e65315549f6cd4e8aa3fd29.woff";